module.exports = __webpack_public_path__ + "assets/images/throbber-d8b390c530a8af5084f94aba693bbf2b.gif";